import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { lightPalette } from '../../../../theme';
import { Root, classes } from './utils';
import AgGrid from '../../common-components/common-ag-grid/AgGrid';
import {
  getScanHistoryChartData,
  getScanHistoryData,
} from '../../../../services/scanHistoryApi';
import scanHistoryColumnDef from './scanHistoryColumnDef';
import { getGridFilterSortStatus } from '../../../../services/allInvoiceApi';

const ScanHistory = ({ organizationId }) => {
  const [showTable, setShowTable] = useState(true);
  const [showChart, setShowChart] = useState(false);
  const [gridSettingData, setGridSettingData] = useState({});

  const handleTableButton = () => {
    setShowTable(true);
    setShowChart(false);
  };

  const handleChartButton = () => {
    setShowTable(false);
    setShowChart(true);
  };

  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('scan-history');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);

  return (
    <Root className={classes.root}>
      <Box className={classes.Table_Chart_Button_Box}>
        <Box className={classes.Table_Chart_Button_Inner_wrapped_Box}>
          <Button
            className={classes.Table_Chart_Button}
            onClick={handleTableButton}
            variant={showTable ? 'contained' : 'text'}
            sx={{
              background: showTable ? lightPalette.japanBlush.main : null,
              color: showTable
                ? lightPalette.darkPurple.main
                : lightPalette.lunarBase.main,
              ':hover': {
                background: showTable ? lightPalette.japanBlush.main : null,
                color: showTable
                  ? lightPalette.darkPurple.main
                  : lightPalette.lunarBase.main,
              },
            }}
          >
            Table
          </Button>
          <Button
            className={classes.Table_Chart_Button}
            onClick={handleChartButton}
            variant={showChart ? 'contained' : 'text'}
            sx={{
              background: showChart ? lightPalette.japanBlush.main : null,
              color: showChart
                ? lightPalette.darkPurple.main
                : lightPalette.lunarBase.main,
              ':hover': {
                background: showChart ? lightPalette.japanBlush.main : null,
                color: showChart
                  ? lightPalette.darkPurple.main
                  : lightPalette.lunarBase.main,
              },
            }}
          >
            Chart
          </Button>
        </Box>
      </Box>

      <Box className={classes.scanHistoryGridBox}>
        {showTable && (
          <AgGrid
            TitleHeader="Scan History"
            className={classes.scanHistoryAgGridStyle}
            showFilterField={showChart}
            columnData={scanHistoryColumnDef}
            getRowData={getScanHistoryData}
            gridSettingData={gridSettingData}
            gridKey="scan-history"
            functionData={organizationId}
            setGridSettingData={setGridSettingData}
          />
        )}
        {showChart && (
          <AgGrid
            TitleHeader="Scan History"
            showFilterField={showChart}
            getRowData={getScanHistoryChartData}
            functionData={organizationId}
          />
        )}
      </Box>
    </Root>
  );
};

ScanHistory.propTypes = {
  organizationId: PropTypes.string.isRequired,
};

export default ScanHistory;
